// === Set this to 'prod' or 'dev' to switch formula API + image endpoints ===
var FORMULA_ENV = "prod";
// =========================================================================

var FORMULA_API =
  FORMULA_ENV === "prod"
    ? "https://api.babybrezzacloud.com/formulas/finder"
    : "https://dev-api.babybrezzacloud.com/formulas/finder";
var FORMULA_IMAGE_BASE =
  FORMULA_ENV === "prod"
    ? "https://babybrezzacloud.com/uploads/formulaprotool/original"
    : "https://dev.babybrezzacloud.com/uploads/formulaprotool/original";

var detecthttp = window.location.protocol;
var isEU = false;
var isProAdvanced = false;
var selected_model_type = "";
var selected_country_code = "";
var selected_formula_brand = "";
var salesforce_url = "https://knowledge.babybrezza.com/s/formula-settings?";
var hasCamera = false;
var detected_upcs = [];
var glob_val;

if (typeof Quagga !== "undefined") {
  Quagga.onDetected(function (result) {
    if (detected_upcs.includes(result.codeResult.code)) {
      detected_upcs = [];
      $("#upc_input").val(result.codeResult.code);
      $("#upc_enter").get(0).click();
      Quagga.stop();
      $("#interactive").hide();
    } else {
      detected_upcs.push(result.codeResult.code);
    }
  });
}

const scrollToID = (id) => {
  if (!$(id).length) return;
  $("html, body").animate(
    { scrollTop: $(id).offset().top - 85 },
    250,
    "swing"
  );
};

$(document).ready(function () {
  $.ajaxSetup({ cache: false });
  injectFormulaProUIStyles();
  ensureImagePreviewModal();
  GetTerritoryData();

  $("#tool_filter .additional-info-btn").click(() => {
    scrollToID("#additional_info_mobile");
  });

  $("#upc_enter").on("keypress click", function (e) {
    if (!checkPrerequisites(true)) {
      $("#sel_type").prop("selectedIndex", 0);
      return;
    }
    if (e.which === 13 || e.type === "click") {
      e.preventDefault();
      let upc = $("#upc_input").val();
      upc = String(upc).trim();
      if (upc) {
        upc = upc.replace(/[^a-z0-9]/gi, "");
        findByUpc(upc);
      }
    }
  });

  $("#start_upc, #upc_start").on("keypress click", function (e) {
    if (!checkPrerequisites(true)) {
      $("#sel_type").prop("selectedIndex", 0);
      return;
    }
    if (e.which === 13 || e.type === "click") {
      e.preventDefault();
      navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
          hasCamera = devices.some(function (device) {
            return device.kind === "videoinput";
          });
          if (hasCamera) {
            $("#result").html("");
            Quagga.init(
              {
                inputStream: {
                  name: "Live",
                  type: "LiveStream",
                  target: document.querySelector("#interactive"),
                  constraints: { facingMode: "environment" }
                },
                decoder: { readers: ["upc_reader", "ean_reader"] },
                locator: { patchSize: 5, halfSample: false },
                numOfWorkers: navigator.hardwareConcurrency || 1,
                frequency: 20,
                locate: true
              },
              function (err) {
                if (err) {
                  console.error(err);
                  return;
                }
                Quagga.start();
                $("#interactive").show();
                Quagga.onProcessed(function (result) {
                  var drawingCtx = Quagga.canvas.ctx.overlay;
                  var drawingCanvas = Quagga.canvas.dom.overlay;
                  drawingCtx.clearRect(
                    0,
                    0,
                    parseInt(drawingCanvas.getAttribute("width")),
                    parseInt(drawingCanvas.getAttribute("height"))
                  );
                  if (result && result.box) {
                    Quagga.ImageDebug.drawPath(
                      result.box,
                      { x: 0, y: 1 },
                      drawingCtx,
                      { color: "#00F", lineWidth: 2 }
                    );
                  }
                });
              }
            );
          } else {
            $("#result").html(
              '<p style="font-size: 16px; font-weight: 700; text-transform: uppercase; margin:0; color: red;">Nebyla detekována kamera</p>'
            );
          }
        })
        .catch(function (err) {
          console.error("Error accessing media devices:", err);
        });
    }
  });
});

function checkEmailSubmit() {
  var emailInput = document.getElementById("enter_email_input");
  if (!emailInput) return true;
  var email = emailInput.value;
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(email)) {
    $("#invalid_email").hide();
    $("#enter_email_input").removeClass("invalid");
    return true;
  } else {
    $("#invalid_email").show();
    $("#enter_email_input").addClass("invalid");
    return false;
  }
}

function checkConsent() {
  var consentInput = document.getElementById("consent_checkbox");
  if (!consentInput) return true;
  if (consentInput.checked) {
    $("#invalid_consent").hide();
    $("#consent_wrapper").removeClass("invalid");
    return true;
  } else {
    $("#invalid_consent").show();
    $("#consent_wrapper").addClass("invalid");
    return false;
  }
}

function checkPrerequisites(focusOnFail) {
  var emailOk = checkEmailSubmit();
  var consentOk = checkConsent();
  if (emailOk && consentOk) return true;
  if (focusOnFail) {
    if (!emailOk) {
      $("#enter_email_input").focus();
    } else {
      $("#consent_checkbox").focus();
    }
  }
  return false;
}

// ---------- API helpers ----------
function safeDecode(v) {
  if (v == null) return "";
  try {
    return decodeURIComponent(v);
  } catch (_) {
    return v;
  }
}

function htmlAttrEscape(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function htmlTextEscape(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function buildOptionsHTML(items, defaultLabel) {
  var html =
    '<option value="">' + htmlTextEscape(defaultLabel || "Vyberte…") + "</option>";
  if (!Array.isArray(items)) return html;
  items.forEach(function (item) {
    var v = htmlAttrEscape(item);
    var t = htmlTextEscape(item);
    html += '<option value="' + v + '">' + t + "</option>";
  });
  return html;
}

function loadingHTML(text) {
  return (
    '<div class="formula-settings-loading" role="status" aria-live="polite">' +
    '<span class="formula-settings-loading__spinner" aria-hidden="true"></span>' +
    '<span class="formula-settings-loading__text">' +
    htmlTextEscape(text || "Načítání…") +
    "</span></div>"
  );
}

function generateImagesHTML(images) {
  if (!images || !images.length) return "";
  var seen = new Set();
  var html = '<div class="formula-images-container">';
  images.forEach(function (img) {
    if (!img || seen.has(img)) return;
    seen.add(img);
    var src = FORMULA_IMAGE_BASE + "/" + img;
    html +=
      '<div class="formula-image-wrapper">' +
      '<img class="formula-image" data-image-preview ' +
      'alt="' +
      htmlAttrEscape(img) +
      '" src="' +
      htmlAttrEscape(src) +
      '" loading="lazy"/></div>';
  });
  html += "</div>";
  return html;
}

function generateSettingsTableHTML(rows) {
  if (!rows || !rows.length) return "<p>Pro tuto kojeneckou výživu nebyla nalezena žádná nastavení.</p>";
  var tableRows = rows
    .map(function (r) {
      var stage =
        r.stage === undefined || r.stage === null || r.stage === ""
          ? "-"
          : r.stage;
      var setting =
        r.setting === undefined || r.setting === null || r.setting === ""
          ? "-"
          : r.setting;
      return (
        "<tr><td>" +
        htmlTextEscape(stage) +
        "</td><td>" +
        htmlTextEscape(setting) +
        "</td></tr>"
      );
    })
    .join("");
  return (
    '<div class="formula-settings-result-wrapper"><table>' +
    "<tr><th>STUPEŇ</th><th>NASTAVENÍ</th></tr>" +
    tableRows +
    "</table></div>"
  );
}

// ---------- Flow handlers ----------
function buildUpcResultCardHTML(item) {
  var brand = item.brand || "";
  var type = item.type || "";
  var stage =
    item.stage === undefined || item.stage === null ? "" : String(item.stage);
  var settingVal =
    item.setting === undefined ||
    item.setting === null ||
    item.setting === ""
      ? "-"
      : item.setting;
  var territory = Array.isArray(item.territory)
    ? item.territory.filter(Boolean).join(", ")
    : item.territory || "";
  var images = Array.isArray(item.image)
    ? item.image
    : Array.isArray(item.images)
    ? item.images
    : [];

  var imageHTML = "";
  if (images.length) {
    var src = FORMULA_IMAGE_BASE + "/" + htmlAttrEscape(images[0]);
    imageHTML =
      '<div class="upc-card-image">' +
      '<img class="formula-image" data-image-preview loading="lazy" ' +
      'alt="' +
      htmlAttrEscape((brand + " " + type).trim()) +
      '" src="' +
      src +
      '" />' +
      "</div>";
  }

  var metaHTML =
    (brand
      ? "<p><strong>Značka:</strong> " + htmlTextEscape(brand) + "</p>"
      : "") +
    (type
      ? "<p><strong>Typ:</strong> " + htmlTextEscape(type) + "</p>"
      : "") +
    (stage
      ? "<p><strong>Stupeň:</strong> " + htmlTextEscape(stage) + "</p>"
      : "") +
    (territory
      ? "<p><strong>Země:</strong> " + htmlTextEscape(territory) + "</p>"
      : "");

  return (
    '<div class="upc-card">' +
    imageHTML +
    '<div class="upc-card-body">' +
    (metaHTML ? '<div class="upc-card-meta">' + metaHTML + "</div>" : "") +
    '<div class="upc-card-setting">' +
    '<span class="upc-card-setting-label">Nastavení</span>' +
    '<span class="upc-card-setting-value">' +
    htmlTextEscape(settingVal) +
    "</span>" +
    "</div>" +
    "</div>" +
    "</div>"
  );
}

function findByUpc(upc) {
  $("#upc_results").show();
  $("#sel_territory").prop("selectedIndex", 0);
  $("#sel_brand").html(
    '<option value="">-- Vyberte značku kojenecké výživy --</option>'
  );
  $("#sel_type").html(
    '<option value="">-- Vyberte stupeň/věkovou kategorii --</option>'
  );
  refreshSelectSearch(document.getElementById("sel_brand"));
  refreshSelectSearch(document.getElementById("sel_type"));
  $("#upc_settings").show();
  $("#upc_settings").html(loadingHTML("Vyhledávání čárového kódu…"));
  $("#find_stage_setting").html("");

  var altMfgSetting = isProAdvanced ? "false" : "";
  var params = new URLSearchParams({ upc: upc });
  if (altMfgSetting) params.set("alt_mfg_setting", altMfgSetting);

  fetch(FORMULA_API + "/settings/upc?" + params.toString())
    .then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    })
    .then(function (data) {
      // API can return either an array (single or multiple matches) or a
      // single object (legacy). Normalize and keep only entries that have a
      // usable setting or UPC.
      var raw = Array.isArray(data) ? data : data ? [data] : [];
      var results = raw.filter(function (r) {
        if (!r) return false;
        var hasSetting =
          r.setting !== undefined && r.setting !== null && r.setting !== "";
        var upcArr = Array.isArray(r.upc) ? r.upc : [];
        return hasSetting || upcArr.length > 0;
      });

      var upcCode = upc;
      if (results.length) {
        var firstUpcArr = Array.isArray(results[0].upc) ? results[0].upc : [];
        if (firstUpcArr.length) upcCode = firstUpcArr[0];
      }

      if (!results.length) {
        $("#upc_settings").html(
          '<h2 style="text-transform:none;margin-top:20px;margin-bottom:15px;font-size:20px;">' +
            "<strong>Pro čárový kód nebyly nalezeny žádné výsledky:</strong> " +
            htmlTextEscape(upcCode) +
            "<br>Vyberte prosím značku/typ kojenecké výživy výše</h2>"
        );
        $("#find_stage_setting").html("");
        $("#formula_pro_filter .Formula_sign_up_con").hide();
        return;
      }

      var headerHTML =
        '<h2 style="text-transform:none;margin-top:20px;margin-bottom:15px;font-size:20px;text-align:center;">' +
        "<strong>Výsledky pro čárový kód:</strong> " +
        htmlTextEscape(upcCode) +
        "</h2>";

      var cardsHTML = results.map(buildUpcResultCardHTML).join("");
      var wrapperClass =
        "upc-result-cards" + (results.length > 1 ? " is-multi" : "");

      $("#upc_settings").html(headerHTML);
      $("#find_stage_setting").html(
        '<div class="' + wrapperClass + '">' + cardsHTML + "</div>"
      );
      $("#formula_pro_filter .Formula_sign_up_con").show();
      scrollToID("#formula_pro_filter .Formula_sign_up_con");
    })
    .catch(function (err) {
      console.error("UPC error:", err);
      $("#upc_settings").html(
        '<h2 style="text-transform:none;margin-top:20px;margin-bottom:15px;font-size:20px;">' +
          "<strong>Pro čárový kód nebyly nalezeny žádné výsledky:</strong> " +
          htmlTextEscape(upc) +
          "<br>Vyberte prosím značku/typ kojenecké výživy výše</h2>"
      );
      $("#find_stage_setting").html("");
    });
}

function proc(model_type) {
  $("#choose_brand_link").hide();
  $("#choose_stage_link").hide();

  if (model_type == "advanced") {
    selected_model_type = "Formula Pro Advanced";
    jQuery("#add_adv").addClass("active");
    jQuery("#add_adv_wifi, #add_pro_mini").removeClass("active");
    isProAdvanced = false;
    $("#contactFormProduct option[value='553111519266']").prop(
      "selected",
      true
    );
  } else if (model_type == "advanced_wifi") {
    selected_model_type = "Formula Pro Advanced WiFi";
    jQuery("#add_adv_wifi").addClass("active");
    jQuery("#add_adv, #add_pro_mini").removeClass("active");
    isProAdvanced = true;
    $("#contactFormProduct option[value='4390264078370']").prop(
      "selected",
      true
    );
  } else if (model_type == "pro_mini") {
    selected_model_type = "Formula Pro Mini";
    jQuery("#add_pro_mini").addClass("active");
    jQuery("#add_adv, #add_adv_wifi").removeClass("active");
    isProAdvanced = false;
    $("#contactFormProduct option[value='7084746244276']").prop(
      "selected",
      true
    );
  }

  $("#productSelectionDiv").hide();
  $("#warranty_regi_div").show();
  jQuery("#model_type").val("advanced");
  GetTerritoryData();
  scrollToID("#formula_pro_filter");
}

function GetTerritoryData() {
  $("#sel_brand").html(
    '<option value="">-- Vyberte značku kojenecké výživy --</option>'
  );
  $("#sel_type").html(
    '<option value="">-- Vyberte stupeň/věkovou kategorii --</option>'
  );
  $("#find_stage_setting").html("");

  fetch(FORMULA_API + "/territories")
    .then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    })
    .then(function (data) {
      $("#sel_territory").html(
        buildOptionsHTML(
          data,
          "-- Vyberte zemi/oblast původu vaší kojenecké výživy --"
        )
      );
      enhanceSelectSearch(document.getElementById("sel_territory"));
      // Make sure the brand & type also have a search input bound to their default state
      enhanceSelectSearch(document.getElementById("sel_brand"));
      enhanceSelectSearch(document.getElementById("sel_type"));
    })
    .catch(function (err) {
      console.error("Territory error:", err);
    });
}

function getbrand(val) {
  if (!checkPrerequisites(true)) {
    $("#sel_territory").prop("selectedIndex", 0);
    refreshSelectSearch(document.getElementById("sel_territory"));
    return;
  }

  var rawTerritory = safeDecode(val || "");
  selected_country_code = val;

  $("#choose_brand_link").css("display", "inline-block");
  $("#choose_stage_link").hide();
  $("#missing_brand").attr(
    "href",
    salesforce_url +
      "product=" +
      selected_model_type +
      "&country=" +
      selected_country_code
  );

  isEU =
    val === "European%20Union" ||
    rawTerritory === "European Union" ||
    val === "European Union";

  $("#sel_territory_id").val(rawTerritory);
  $("#sel_brand_id").val("");
  $("#sel_type_id").val("");

  $(
    "#us_store_brnd_description, #us_store_brnd_description_mobile, #formula_brand_tooltip"
  ).hide();
  if (
    rawTerritory === "United States of America" ||
    val === "United%20States%20of%20America"
  ) {
    $(
      "#us_store_brnd_description, #us_store_brnd_description_mobile, #formula_brand_tooltip"
    ).show();
  }

  $("#choose_type").show();
  $("#sel_type").html(
    '<option value="">-- Vyberte stupeň/věkovou kategorii kojenecké výživy --</option>'
  );
  refreshSelectSearch(document.getElementById("sel_type"));
  $("#find_stage_setting").html("");

  if (!rawTerritory) return;

  setSelectLoading(document.getElementById("sel_brand"), true);
  var params = new URLSearchParams({ territory: rawTerritory });
  fetch(FORMULA_API + "/brands?" + params.toString())
    .then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    })
    .then(function (data) {
      $("#sel_brand").html(
        buildOptionsHTML(data, "-- Vyberte značku kojenecké výživy --")
      );
      enhanceSelectSearch(document.getElementById("sel_brand"));
    })
    .catch(function (err) {
      console.error("Brand error:", err);
    })
    .finally(function () {
      setSelectLoading(document.getElementById("sel_brand"), false);
    });
}

function gettypepro(val) {
  if (!checkPrerequisites(true)) {
    $("#sel_brand").prop("selectedIndex", 0);
    refreshSelectSearch(document.getElementById("sel_brand"));
    return;
  }

  selected_formula_brand = val;
  $("#choose_stage_link").css("display", "inline-block");
  $("#missing_stage").attr(
    "href",
    salesforce_url +
      "product=" +
      selected_model_type +
      "&country=" +
      selected_country_code +
      "&formula_name=" +
      selected_formula_brand
  );

  $("#sel_brand_id").val(val);
  $("#sel_type_id").val("");

  var rawTerritory = safeDecode($("#sel_territory_id").val() || "");
  var rawBrand = safeDecode(val || "");

  $("#choose_type").show();
  $("#find_stage_setting").html("");

  if (!rawBrand) return;

  setSelectLoading(document.getElementById("sel_type"), true);
  var params = new URLSearchParams({ territory: rawTerritory, brand: rawBrand });
  fetch(FORMULA_API + "/types?" + params.toString())
    .then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    })
    .then(function (data) {
      $("#sel_type").html(
        buildOptionsHTML(data, "-- Vyberte stupeň/věkovou kategorii kojenecké výživy --")
      );
      enhanceSelectSearch(document.getElementById("sel_type"));
    })
    .catch(function (err) {
      console.error("Type error:", err);
    })
    .finally(function () {
      setSelectLoading(document.getElementById("sel_type"), false);
    });
}

function getstagesettign(val) {
  if (!checkPrerequisites(true)) {
    $("#sel_type").prop("selectedIndex", 0);
    refreshSelectSearch(document.getElementById("sel_type"));
    return;
  }

  $("#upc_settings").hide();
  $("#upc_input").val("");
  glob_val = val;
  $("#sel_type_id").val(val);

  if (!val) {
    $("#find_stage_setting").html("");
    return;
  }

  $("#find_stage_setting").html(loadingHTML("Načítání nastavení…"));

  var rawTerritory = safeDecode($("#sel_territory_id").val() || "");
  var rawBrand = safeDecode($("#sel_brand_id").val() || "");
  var rawType = safeDecode(val || "");
  var altMfgSetting = isProAdvanced ? "false" : "";

  // Fire-and-forget legacy analytics ping (preserves existing reporting flow)
  sendLegacySettingsLog({
    rawTerritory: rawTerritory,
    rawBrand: rawBrand,
    rawType: rawType
  });

  var stagesParams = new URLSearchParams({
    territory: rawTerritory,
    brand: rawBrand,
    type: rawType
  });

  fetch(FORMULA_API + "/stages?" + stagesParams.toString())
    .then(function (r) {
      if (!r.ok) throw new Error("HTTP " + r.status);
      return r.json();
    })
    .then(function (stages) {
      if (!Array.isArray(stages) || !stages.length) return [];
      return Promise.all(
        stages.map(function (stageItem) {
          var stageValue, stageName;
          if (stageItem && typeof stageItem === "object") {
            stageValue =
              stageItem.stage != null ? stageItem.stage : stageItem.number;
            stageName = stageItem.name || stageItem.label || String(stageValue);
          } else {
            stageValue = String(stageItem);
            stageName = stageValue;
          }
          var p = new URLSearchParams({
            territory: rawTerritory,
            brand: rawBrand,
            type: rawType
          });
          if (
            stageValue !== "" &&
            stageValue !== undefined &&
            stageValue !== null
          ) {
            p.set("stage", stageValue);
          }
          if (altMfgSetting) p.set("alt_mfg_setting", altMfgSetting);
          return fetch(FORMULA_API + "/settings?" + p.toString())
            .then(function (r) {
              return r.ok ? r.json() : { setting: "", upc: [], image: [] };
            })
            .then(function (s) {
              return {
                stage: stageName,
                stageNum: stageValue,
                setting: s && s.setting,
                upc: (s && s.upc) || [],
                image: (s && s.image) || []
              };
            });
        })
      );
    })
    .then(function (rows) {
      var html = generateSettingsTableHTML(rows);
      var seen = new Set();
      var allImages = [];
      (rows || []).forEach(function (r) {
        (r.image || []).forEach(function (img) {
          if (!seen.has(img)) {
            seen.add(img);
            allImages.push(img);
          }
        });
      });
      html += generateImagesHTML(allImages);
      $("#find_stage_setting").html(html);
      $(".Formula_sign_up_con").show();
      $("#enjoy-msg, #fps-mail-cta, #more-products-wrapper").show();
      tryInitMoreSlider();
      scrollToID("#formula_pro_filter .Formula_sign_up_con");
    })
    .catch(function (err) {
      console.error("Settings error:", err);
      $("#find_stage_setting").html("");
    });
}

function getData() {
  if (glob_val) getstagesettign(glob_val);
}

window.addEventListener("klaviyoForms", function (e) {
  if (e.detail && e.detail.type === "submit") getData();
});

var skipBtn = document.querySelector(".fpa_skip");
if (skipBtn) {
  skipBtn.addEventListener("click", function (e) {
    e.preventDefault();
    getData();
  });
}

function tryInitMoreSlider() {
  if (
    window.$ &&
    $(".more-slider").length &&
    $.fn &&
    $.fn.slick &&
    !$(".more-slider").hasClass("slick-initialized")
  ) {
    try {
      $(".more-slider").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        focusOnSelect: true,
        draggable: true,
        swipeToSlide: true,
        responsive: [
          { breakpoint: 768, settings: { slidesToShow: 2 } },
          { breakpoint: 1024, settings: { slidesToShow: 3 } },
          { breakpoint: 1400, settings: { slidesToShow: 4 } }
        ]
      });
      $(window).on("resize orientationchange", function () {
        $(".more-slider").slick("resize");
      });
    } catch (_) {}
  }
}

function getUserCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

function sendLegacySettingsLog(opts) {
  try {
    var fd = new URLSearchParams();
    fd.append("type_id", opts.rawType || "");
    fd.append(
      "brand_id",
      opts.rawBrand ? encodeURIComponent(opts.rawBrand) : ""
    );
    fd.append("territory_id", opts.rawTerritory || "");
    fd.append("model_type", $("#model_type").val() || "");
    fd.append("email", $("#enter_email_input").val() || "");
    fd.append("language", document.documentElement.lang || "en");
    fd.append("ip_address", getUserCookie("ip_address") || "");
    fd.append("user_agent", navigator.userAgent);
    fd.append(
      "touch_device",
      String("ontouchstart" in window || navigator.maxTouchPoints > 0)
    );
    fd.append("state_prov", getUserCookie("state_prov") || "");
    fd.append("zip", getUserCookie("zip") || "");
    fd.append("country", getUserCookie("country") || "");
    fd.append("city", getUserCookie("city") || "");
    fd.append("babyb_store", "babybrezza.com");
    fetch(
      "https://babybrezzaserver.com/index.php/without_response/getsetting",
      { method: "POST", body: fd, keepalive: true }
    ).catch(function () {});
  } catch (_) {}
}

// Legacy helper retained for any third-party integration that still calls it.
function crossDomainAjax(url, querystring, successCallback) {
  $.ajax({
    url: url,
    cache: false,
    type: "POST",
    data: querystring,
    success: function (data) {
      successCallback(data);
    }
  });
}

// =========================
// Searchable dropdown helper
// =========================
function setSelectLoading(selectEl, isLoading) {
  if (!selectEl) return;
  selectEl.disabled = !!isLoading;
  if (selectEl._searchInput) selectEl._searchInput.disabled = !!isLoading;
}

function enhanceSelectSearch(selectEl) {
  if (!selectEl || !selectEl.parentNode) return;
  if (selectEl.dataset.searchEnhanced === "1") {
    refreshSelectSearch(selectEl);
    return;
  }
  selectEl.dataset.searchEnhanced = "1";

  selectEl.style.display = "none";
  selectEl.setAttribute("aria-hidden", "true");
  selectEl.setAttribute("tabindex", "-1");

  var searchInput = document.createElement("input");
  searchInput.type = "search";
  searchInput.className = "search-select-input formula-search-select-input";
  searchInput.setAttribute("autocomplete", "off");
  searchInput.setAttribute("autocorrect", "off");
  searchInput.setAttribute("autocapitalize", "off");
  searchInput.setAttribute("spellcheck", "false");
  searchInput.setAttribute("role", "combobox");
  selectEl.insertAdjacentElement("afterend", searchInput);

  var dropdown = document.createElement("div");
  dropdown.className =
    "search-select-dropdown formula-search-select-dropdown";
  dropdown.hidden = true;
  dropdown.setAttribute("role", "listbox");
  document.body.appendChild(dropdown);

  function position() {
    var rect = searchInput.getBoundingClientRect();
    var vv = window.visualViewport;
    var vvTop = vv ? vv.offsetTop : 0;
    var vvLeft = vv ? vv.offsetLeft : 0;
    var vvHeight = vv ? vv.height : window.innerHeight;
    var spaceBelow = vvHeight - rect.bottom;
    var availableH = Math.max(140, Math.min(280, spaceBelow - 8));
    dropdown.style.maxHeight = availableH + "px";
    dropdown.style.left = rect.left + vvLeft + "px";
    dropdown.style.width = rect.width + "px";
    dropdown.style.top = rect.bottom + vvTop + 2 + "px";
  }

  function render(filter) {
    dropdown.innerHTML = "";
    var f = (filter || "").trim().toLowerCase();
    var items = Array.from(selectEl.options).filter(function (o) {
      return o.value;
    });
    var matches = f
      ? items.filter(function (o) {
          return o.text.toLowerCase().includes(f);
        })
      : items;
    if (!matches.length) {
      var empty = document.createElement("div");
      empty.className = "search-select-empty";
      empty.textContent = "Žádné výsledky";
      dropdown.appendChild(empty);
      return;
    }
    matches.forEach(function (opt) {
      var item = document.createElement("div");
      item.className = "search-select-option";
      item.textContent = opt.text;
      item.dataset.value = opt.value;
      item.setAttribute("role", "option");
      if (opt.value === selectEl.value) item.classList.add("is-active");
      item.addEventListener("mousedown", function (e) {
        e.preventDefault();
        if (selectEl.value === opt.value) {
          dropdown.hidden = true;
          return;
        }
        selectEl.value = opt.value;
        searchInput.value = opt.text;
        dropdown.hidden = true;
        // dispatchEvent triggers BOTH the inline `onchange="..."` attribute
        // AND any addEventListener('change') listeners — do not also invoke
        // selectEl.onchange manually or handlers fire twice.
        selectEl.dispatchEvent(new Event("change", { bubbles: true }));
      });
      dropdown.appendChild(item);
    });
  }

  searchInput.addEventListener("focus", function () {
    render("");
    position();
    dropdown.hidden = false;
    searchInput.select();
  });
  searchInput.addEventListener("click", function () {
    if (dropdown.hidden) {
      render("");
      position();
      dropdown.hidden = false;
      searchInput.select();
    }
  });
  searchInput.addEventListener("input", function () {
    render(searchInput.value);
    position();
    dropdown.hidden = false;
  });
  searchInput.addEventListener("blur", function () {
    setTimeout(function () {
      dropdown.hidden = true;
      var sel = selectEl.options[selectEl.selectedIndex];
      searchInput.value = sel && sel.value ? sel.text : "";
    }, 150);
  });
  searchInput.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      dropdown.hidden = true;
      searchInput.blur();
    }
  });
  window.addEventListener(
    "scroll",
    function () {
      if (!dropdown.hidden) position();
    },
    true
  );
  window.addEventListener("resize", function () {
    if (!dropdown.hidden) position();
  });
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", function () {
      if (!dropdown.hidden) position();
    });
    window.visualViewport.addEventListener("scroll", function () {
      if (!dropdown.hidden) position();
    });
  }

  selectEl._searchInput = searchInput;
  selectEl._searchDropdown = dropdown;
  refreshSelectSearch(selectEl);
}

function refreshSelectSearch(selectEl) {
  if (!selectEl) return;
  var searchInput = selectEl._searchInput;
  if (!searchInput) return;
  var firstOpt = selectEl.options[0];
  var sel = selectEl.options[selectEl.selectedIndex];
  searchInput.placeholder = firstOpt ? firstOpt.text : "Vyberte…";
  searchInput.value = sel && sel.value ? sel.text : "";
}

// =========================
// Image preview modal
// =========================
function ensureImagePreviewModal() {
  if (document.getElementById("formula-image-preview-modal")) return;
  var modal = document.createElement("div");
  modal.id = "formula-image-preview-modal";
  modal.className = "formula-image-preview-modal";
  modal.setAttribute("aria-hidden", "true");
  modal.setAttribute("role", "dialog");
  modal.innerHTML =
    '<button type="button" class="formula-image-preview-close" aria-label="Zavřít">&times;</button>' +
    '<img alt="" />';
  document.body.appendChild(modal);

  var imgEl = modal.querySelector("img");
  var closeBtn = modal.querySelector(".formula-image-preview-close");

  function close() {
    modal.setAttribute("aria-hidden", "true");
    imgEl.src = "";
    document.body.style.overflow = "";
  }

  modal.addEventListener("click", function (e) {
    if (e.target === modal) close();
  });
  closeBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    close();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false")
      close();
  });

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || t.tagName !== "IMG") return;
    if (
      !t.classList.contains("formula-image") &&
      !t.matches("[data-image-preview]")
    ) {
      return;
    }
    if (
      !t.closest(
        "#find_stage_setting, #upc_settings, #upc_results, .formula-images-container"
      )
    )
      return;
    e.preventDefault();
    imgEl.src = t.src;
    imgEl.alt = t.alt || "";
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  });
}

// =========================
// One-time CSS injection
// =========================
function injectFormulaProUIStyles() {
  if (document.getElementById("formulapro-ui-styles")) return;
  var style = document.createElement("style");
  style.id = "formulapro-ui-styles";
  style.textContent =
    ".upc-result-cards{display:grid;grid-template-columns:1fr;gap:18px;max-width:560px;margin:10px auto;align-items:stretch;}" +
    ".upc-result-cards.is-multi{grid-template-columns:repeat(2,minmax(0,1fr));max-width:900px;}" +
    "@media (max-width:640px){.upc-result-cards.is-multi{grid-template-columns:1fr;max-width:560px;}}" +
    ".upc-card{display:flex;flex-direction:column;background:#fff;border:1px solid #e3e6e8;border-radius:10px;box-shadow:0 1px 3px rgba(0,0,0,.06);overflow:hidden;height:100%;}" +
    ".upc-card-image{display:flex;align-items:center;justify-content:center;background:#f7fafb;padding:14px;height:200px;flex:0 0 200px;}" +
    ".upc-card-image img.formula-image{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;}" +
    ".upc-card-body{padding:14px 16px 16px;display:flex;flex-direction:column;flex:1 1 auto;gap:10px;}" +
    ".upc-card-meta{flex:1 1 auto;}" +
    ".upc-card-meta p{margin:2px 0;color:#1a2b33;font-size:14px;line-height:1.4;}" +
    ".upc-card-meta p strong{color:#20809b;}" +
    ".upc-card-setting{display:flex;align-items:center;justify-content:space-between;margin-top:auto;padding:10px 14px;background:#20809b;color:#fff;border-radius:6px;}" +
    ".upc-card-setting-label{font-size:13px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;}" +
    ".upc-card-setting-value{font-size:22px;font-weight:700;line-height:1;}" +
    ".formula-images-container{display:flex;flex-wrap:wrap;gap:12px;justify-content:center;margin:16px auto;}" +
    ".formula-image-wrapper{flex:0 0 auto;}" +
    ".formula-image{display:block;max-width:250px;max-height:300px;width:auto;height:auto;cursor:zoom-in;border-radius:4px;background:#fff;}" +
    ".formula-settings-loading{display:flex;align-items:center;gap:10px;justify-content:center;padding:20px;font-size:15px;color:#333;}" +
    ".formula-settings-loading__spinner{width:18px;height:18px;border:2px solid #ddd;border-top-color:#20809b;border-radius:50%;animation:fps-spin 0.8s linear infinite;display:inline-block;}" +
    "@keyframes fps-spin{to{transform:rotate(360deg);}}" +
    ".formula-search-select-input{display:block;width:100%;max-width:400px;padding:8px 12px;border:1px solid #bcbec0;border-radius:2px;background:#fff;font-size:16px;margin:4px 0 10px;box-sizing:border-box;}" +
    ".formula-search-select-input:focus{outline:2px solid #20809b;}" +
    ".formula-search-select-dropdown{position:fixed;background:#fff;border:1px solid #bcbec0;border-radius:4px;box-shadow:0 6px 18px rgba(0,0,0,0.12);overflow-y:auto;z-index:2147483646;}" +
    ".search-select-option{padding:8px 12px;cursor:pointer;font-size:15px;color:#222;}" +
    ".search-select-option:hover,.search-select-option.is-active{background:#eaf3f7;}" +
    ".search-select-empty{padding:8px 12px;color:#888;font-style:italic;}" +
    ".formula-image-preview-modal{position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:2147483647;display:none;align-items:center;justify-content:center;padding:24px;cursor:zoom-out;}" +
    '.formula-image-preview-modal[aria-hidden="false"]{display:flex;}' +
    ".formula-image-preview-modal img{max-width:min(92vw,1200px);max-height:90vh;width:auto;height:auto;box-shadow:0 12px 32px rgba(0,0,0,0.4);border-radius:6px;background:#fff;cursor:default;}" +
    ".formula-image-preview-close{position:absolute;top:18px;right:24px;background:#fff;border:none;border-radius:999px;width:36px;height:36px;font-size:22px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(0,0,0,0.3);}";
  document.head.appendChild(style);
}
